// Add Minutes Func
export function addMinutes(date, minutes) {
    const addMuniteDate = new Date(date);
    addMuniteDate.setMinutes(date.getMinutes() + minutes);

    return addMuniteDate;
}
